import bsModal from 'bootstrap/js/dist/modal';
import { reactive } from 'vue';
import Component from './component.vue'

export default {
  install(app) {
    app.component('BsModal', Component)

    const instances = reactive(new Map())

    const getEl = id => {
      const el = document.getElementById(id)
      if (!el) {
        console.warn(`[ModalPlugin] Modal with id "${id}" not found`)
      }
      return el
    }

    const getInstance = (id, options) => {
      if (instances.has(id)) {
        return instances.get(id)
      }

      const el = getEl(id)
      if (!el) return null

      const instance = new bsModal(el, options)
      instances.set(id, instance)
      return instance
    }

    const show = (id, options = {}) => {
      const instance = getInstance(id, options)
      instance?.show()
    }

    const hide = id => {
      const instance = instances.get(id)
      if (!instance) {
        console.warn(`[ModalPlugin] Cannot hide modal "${id}" — instance not found`)
        return
      }
      instance.hide()
    }

    const onShown = (id, callback) => {
      const el = document.getElementById(id);
      el?.addEventListener('shown.bs.modal', () => {
        callback(id);
      });
    }

    const onHide = (id, callback) => {
      const el = document.getElementById(id);
      el?.addEventListener('hide.bs.modal', () => {
        callback(id);
      });
    }

    const onHidden = (id, callback) => {
      const el = document.getElementById(id);
      el?.addEventListener('hidden.bs.modal', () => {
        callback(id);
      });
    }

    const modal = {
      show,
      hide,
      onShown,
      onHide,
      onHidden,
      _instances: instances // optional για debugging
    }

    app.config.globalProperties.$modal = modal
    app.provide('$modal', modal)
  }
}